import { html, customElement } from '@adobe/edex/ui/edex-lit';
import { PrimarySecondary, ProductSchema } from '@adobe/edex/ui/types';
import { mergePrimarySecondary } from '@adobe/edex/ui/utils';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import { ToolBase } from '@adobe/edex/ui/components/shared/tools/tool-base';

import '@adobe/edex/ui/components/resource/resource-sidebar/tools.scss';
import { until } from 'lit/directives/until.js';

@customElement(EdexTagName.toolsNew)
export class Tools extends ToolBase {
  get useLightDom() {
    return true;
  }

  static get properties() {
    return {
      ...super.properties,
      products: { type: Object },
    };
  }

  products: PrimarySecondary<ProductSchema>;

  async connectedCallback() {
    super.connectedCallback();

    // handle legacy data
    if (!this.products.primary && this.products.secondary.length === 1) {
      this.products.primary = this.products.secondary.shift();
    }
  }

  renderProduct = (product: ProductSchema) => {
    return html`
      <div class="product">
        ${this.renderProductLogo(product)} ${this.renderProductTitle(product)} ${until(this.renderTryLink(product))}
      </div>
    `;
  };

  render() {
    const {
      products: { primary, secondary },
    } = this;
    const products = mergePrimarySecondary({ primary, secondary });
    return html`
      <div class="tools-container">${products.map(this.renderProduct)}</div>
    `;
  }
}
